export default [
  {
    path: 'applied-doc-count-by-org',
    name: 'applied-doc-count-by-org',
    component: () => import('@/views/pages/front/applied-doc-count-by-org/AppliedDocCountByOrganization.vue'),
    meta: {
      pageTitle: 'Applied doc count by organization',
      breadcrumb: [
        {
          text: 'Applied doc count by organization',
          active: true,
        },
      ],
    },
  },
  {
    path: 'applied-doc-count-by-org/:orgId/period/:periodId',
    name: 'applied-doc-count-by-direction',
    component: () => import('@/views/pages/front/applied-doc-count-by-org/AppliedDocCountByDirection.vue'),
    meta: {
      pageTitle: 'Applied doc count by direction',
      breadcrumb: [
        {
          text: 'Applied doc count by direction',
          active: true,
        },
      ],
    },
  },
]
